document.addEventListener('click', event => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').removeAttribute('open');
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    const menu = document.querySelector('.mobile-menu[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  }
});
document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-select]')) {
    const section = event.target.closest('[data-product-section]');
    const option = event.target.selectedOptions[0];
    const button = section.querySelector('[data-add-to-cart]');
    const price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to bag'; }
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  }
});
document.addEventListener('submit', event => {
  const button = event.target.querySelector('[data-add-to-cart]');
  if (button) { button.disabled = true; button.textContent = 'Adding to bag…'; }
});
